import React from 'react';

import { makeStyles } from '@mui/styles';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const useStyles = makeStyles(theme => ({
  imgFlg : {
    border: '3px solid',
    display: 'flex',
    width: '30px',
   
    justifyContent: 'flex-Start',
  },
  img1: {
    width: '25px',
    position: 'relative',
    marginRight: '10px',
    marginTop: '5px',
    borderRadius: '20px'
  },
  img2: {
    width: '25px',
    position: 'relative',
    marginRight: '5px',
    marginTop: '5px'
  },
  icons: {
    position: 'relative',
    marginTop: '2px'
  },
  mainImg: {
    display: 'flex',
    
  },
  imgs: {
    display: 'flex',
    justifyContent: 'center'
  },
  imgFlag: {
    display: 'flex',
    border: '1px solid'
  },
  mainIcon:{
    borderRadius: '5px' 
  },
  IconImg:{
    minWidth: '40px',
    marginLeft: '20px',
    paddingRight: '5px'
  }
}));

const MenuBody = (props) => {
  const classes = useStyles();
  return (
    <>
      {props.title}
      {props.isOpen ? 
        <div className={classes.mainImg}>
          <div className={classes.imgs}>
            <div className={classes.img1}>
              <img src={props.flag}/>
            </div>
            <div className={classes.img2}>
              <img src={props.flag2}/>
            </div>
          </div>
          <div className={classes.icons}>
            {props.icon === props.idiom?
              <CheckCircleOutlineIcon/>
              :
              <RadioButtonUncheckedIcon/>}
          </div>
        </div> 
      : ''}
    </>
  )
};

export default MenuBody;
